import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { SidebarService } from './sidebar.service';
import { RouterModule, Router } from '@angular/router';
import { VersionService } from '../../../shared/services/version.service';
import { IconComponent } from '../icon/icon.component';
import { SidebarLinkComponent } from './link/link.component';
import { MePipe } from '../../pipes/me.pipe';
import { BranchPipe } from '../../pipes/branch.pipe';
import { HasRoleDirective } from '../../directives/has-role.directive';
import { AuthService } from '../../../features/auth/auth.service';
import { adminAccess } from '@src/app/core/lists/AdminAccessRoles';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    IconComponent,
    RouterModule,
    SidebarLinkComponent,
    MePipe,
    BranchPipe,
    HasRoleDirective,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  roles!: any;

  menus!: any;

  adminAccess = adminAccess;

  server: any = {};

  checklist: any = {};

  classLinks =
    'disabled:opacity-40 flex items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg pl-3 group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700';

  constructor(
    private sidebarService: SidebarService,
    public versionService: VersionService,
    public authService: AuthService,
    private router: Router,
  ) {}

  isOpen = true;

  ngOnInit(): void {
    this.initMenus();

    const data = localStorage.getItem('diskUsage');
    if (data) {
      const parsed = JSON.parse(data);
      this.server = parsed.server;
      this.checklist = parsed.checklist;
    }
  }

  close() {
    this.isOpen = false;
    setTimeout(() => this.sidebarService.emitClose(), 200);
  }

  initMenus() {
    this.menus = {
      admin: { open: false },
      dash: { open: false },
      patio: { open: false },
      entradas: { open: false },
    };
  }

  openMenu(menu: string) {
    this.menus[menu].open = !this.menus[menu].open;
  }

  goToLitwo() {
    window.open('https://litwo.com.br/', '_blank');
  }

  changeBranch() {
    const hasRole = this.authService.roles.some((role: string) =>
      role.includes('ADMIN'),
    );

    if (hasRole) {
      this.authService.branch = null;
      this.router.navigate(['/']);
      this.close();
    }
  }
}
